import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-85879912"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"navi01\" data-v-85879912><ul class=\"navi1\" data-v-85879912><li class=\"nvai2\" data-v-85879912>常用网站</li><li class=\"nvai2\" data-v-85879912><a class=\"a1\" href=\"http://www.ccgp.gov.cn/\" target=\"_blank\" data-v-85879912>中国政府采购网</a></li><li class=\"nvai2\" data-v-85879912><a class=\"a1\" href=\"https://www.creditchina.gov.cn/\" target=\"_blank\" data-v-85879912>信用中国</a></li><li class=\"nvai2\" data-v-85879912><a class=\"a1\" href=\"https://www.gsxt.gov.cn/\" target=\"_blank\" data-v-85879912>国家企业信息信用信息系统</a></li><li class=\"nvai2\" data-v-85879912><a class=\"a1\" href=\"https://zxgk.court.gov.cn\" target=\"_blank\" data-v-85879912>中国执行公开网</a></li><li class=\"nvai2\" data-v-85879912><a class=\"a1\" href=\"https://wenshu.court.gov.cn/\" target=\"_blank\" data-v-85879912>中国裁判文书网</a></li><li class=\"nvai2\" data-v-85879912><a class=\"a1\" href=\"https://jzsc.mohurd.gov.cn/\" target=\"_blank\" data-v-85879912>全国建筑市场监管公共服务平台</a></li><li class=\"nvai2\" data-v-85879912><a class=\"a1\" href=\"https://glxy.mot.gov.cn/\" target=\"_blank\" data-v-85879912>全国公路建设市场信用信息管理系统</a></li><li class=\"nvai2\" data-v-85879912><a class=\"a1\" href=\"http://scjg.mwr.gov.cn/\" target=\"_blank\" data-v-85879912>全国水利建设市场监管平台</a></li><li class=\"nvai2\" data-v-85879912><a class=\"a1\" href=\"http://cebpubservice.cn/\" target=\"_blank\" data-v-85879912>中国招标投标公共服务平台</a></li></ul><ul class=\"navi1\" data-v-85879912><li class=\"nvai2\" data-v-85879912>自治区常用网站</li><li class=\"nvai2\" data-v-85879912><a class=\"a1\" href=\"http://ggzy.xizang.gov.cn\" target=\"_blank\" data-v-85879912>西藏自治区公共资源交易中心</a></li><li class=\"nvai2\" data-v-85879912><a class=\"a1\" href=\"https://cg.zbj.com/\" target=\"_blank\" data-v-85879912>西藏自治区昌都市电子卖场·商品超市</a></li><li class=\"nvai2\" data-v-85879912><a class=\"a1\" href=\"http://www.ccgp-xizang.gov.cn/\" target=\"_blank\" data-v-85879912>西藏采购网</a></li><li class=\"nvai2\" data-v-85879912><a class=\"a1\" href=\"http://slt.xizang.gov.cn/\" target=\"_blank\" data-v-85879912>西藏自治区水利厅</a></li><li class=\"nvai2\" data-v-85879912><a class=\"a1\" href=\"http://221.13.83.27:8010/#/index\" target=\"_blank\" data-v-85879912>西藏自治区建筑市场监管公共服务平台</a></li><li class=\"nvai2\" data-v-85879912><a class=\"a1\" href=\"http://zjt.xizang.gov.cn/\" target=\"_blank\" data-v-85879912>西藏自治区住房和城乡建设厅</a></li><li class=\"nvai2\" data-v-85879912><a class=\"a1\" href=\"https://jtt.xizang.gov.cn/\" target=\"_blank\" data-v-85879912>西藏自治区交通运输厅</a></li><li class=\"nvai2\" data-v-85879912><a class=\"a1\" href=\"https://beian.miit.gov.cn\" target=\"_blank\" data-v-85879912>蜀ICP备2021024608号-1</a></li></ul></div>", 1);
const _hoisted_2 = {
  class: "expen"
};
const _hoisted_3 = {
  class: "exp3"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "ptext"
}, [/*#__PURE__*/_createTextVNode(" 中华人民共和国国家计划委员会 [计价格 ［2002］1980号] 招标代理服务收费管理暂行办法 (2002-10-15发布) "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 国家发展改革委关于降低部分建设项目 收费标准规范收费行为等有关问题的通知 发改价格[2011]534号 ")], -1));
const _hoisted_5 = {
  class: "exp1"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "p1"
}, "招标代理费用计算器", -1));
const _hoisted_7 = {
  class: "form1",
  action: "jisuan"
};
const _hoisted_8 = {
  class: "p2"
};
const _hoisted_9 = {
  class: "exp2"
};
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_el_table, {
    data: $setup.tableData,
    border: "",
    style: {
      "width": "100%"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "jine",
      label: "中标金额"
    }), _createVNode(_component_el_table_column, {
      prop: "leix",
      label: "货物招标"
    }), _createVNode(_component_el_table_column, {
      prop: "leix2",
      label: "服务招标"
    }), _createVNode(_component_el_table_column, {
      prop: "leix3",
      label: "工程招标"
    })]),
    _: 1
  }, 8, ["data"])]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("form", _hoisted_7, [_createVNode(_component_el_input, {
    class: "eli1",
    modelValue: $setup.input,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.input = $event),
    type: "number",
    placeholder: "请输入纯数字"
  }, null, 8, ["modelValue"]), _createVNode(_component_el_radio_group, {
    modelValue: $setup.radio,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.radio = $event)
  }, {
    default: _withCtx(() => [_createVNode(_component_el_radio, {
      checked: "true",
      label: 3
    }, {
      default: _withCtx(() => [_createTextVNode("工程")]),
      _: 1
    }), _createVNode(_component_el_radio, {
      label: 6
    }, {
      default: _withCtx(() => [_createTextVNode("服务")]),
      _: 1
    }), _createVNode(_component_el_radio, {
      label: 9
    }, {
      default: _withCtx(() => [_createTextVNode("货物    ")]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_button, {
    onClick: $setup.exp4,
    type: "success"
  }, {
    default: _withCtx(() => [_createTextVNode("点击计算")]),
    _: 1
  }, 8, ["onClick"])]), _createElementVNode("p", _hoisted_8, "￥" + _toDisplayString($setup.exp3), 1)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("p", {
    class: "ptext4",
    innerHTML: $setup.text1
  }, null, 8, _hoisted_10), _hoisted_11, _createVNode(_component_el_table, {
    data: $setup.tableData1,
    border: "",
    style: {
      "width": "100%"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "jiage",
      label: "价格区间"
    }), _createVNode(_component_el_table_column, {
      prop: "zbj",
      label: "计算价格(元)"
    }), _createVNode(_component_el_table_column, {
      prop: "gongs",
      label: "计算公式(元)"
    }), _createVNode(_component_el_table_column, {
      prop: "jieguo",
      label: "计算结果(元)"
    })]),
    _: 1
  }, 8, ["data"])])])], 64);
}